// /**
//  * Global Product Variant Selector - Enhanced for Product Recommendations
//  * Handles variant switching for all product cards including AJAX-loaded content
//  */

// (function() {
//   'use strict';

//   console.log('🚀 Variant Selector Loading');

//   class ProductVariantSelector {
//     constructor(productCard) {
//       this.productCard = productCard;
      
//       // Skip if already initialized
//       if (this.productCard.dataset.variantSelectorInitialized === 'true') {
//         console.log('⏭️ Card already initialized, skipping');
//         return;
//       }
      
//       this.hasVariantSelector = this.productCard.querySelector('[data-variant-selector]') !== null;
      
//       if (this.hasVariantSelector) {
//         console.log('✅ Initializing card:', this.productCard.dataset.productHandle);
//         this.init();
//         this.productCard.dataset.variantSelectorInitialized = 'true';
//       } else {
//         console.log('⏭️ No variant selector found in card');
//       }
//     }

//     init() {
//       // Get all necessary elements
//       this.variantRadios = this.productCard.querySelectorAll('.variant-radio');
//       this.priceWrapper = this.productCard.querySelector('[data-price-wrapper]');
//       this.variantIdInput = this.productCard.querySelector('.variant-id-input');
//       this.variantIdInputCart = this.productCard.querySelector('.variant-id-input-cart');
//       this.addToCartButton = this.productCard.querySelector('.product-card__add-to-cart-button');
//       this.defaultVariantId = this.productCard.dataset.defaultVariantId;
//       this.productHandle = this.productCard.dataset.productHandle;
//       this.mainImage = this.productCard.querySelector('[data-main-image="true"]');
//       this.secondaryImage = this.productCard.querySelector('[data-secondary-image="true"]');
//       this.imageWrapper = this.productCard.querySelector('.product-card__image-wrapper');

//       console.log('📦 Elements found:', {
//         variants: this.variantRadios.length,
//         priceWrapper: !!this.priceWrapper,
//         button: !!this.addToCartButton
//       });

//       if (this.variantRadios.length === 0) {
//         console.log('⚠️ No variant radios found');
//         return;
//       }

//       this.setupEventListeners();
//       this.setupImageHoverEffect();
//       this.initializeDefaultVariant();
//     }

//     setupImageHoverEffect() {
//       if (!this.imageWrapper || !this.mainImage || !this.secondaryImage) {
//         console.log('ℹ️ Image hover disabled - missing elements');
//         return;
//       }

//       this.imageWrapper.addEventListener('mouseenter', () => {
//         this.mainImage.style.opacity = '0';
//         this.secondaryImage.style.opacity = '1';
//       });

//       this.imageWrapper.addEventListener('mouseleave', () => {
//         this.mainImage.style.opacity = '1';
//         this.secondaryImage.style.opacity = '0';
//       });
      
//       console.log('🖼️ Image hover effect enabled');
//     }

//     setupEventListeners() {
//       console.log('🎧 Setting up event listeners...');
      
//       this.variantRadios.forEach((radio, index) => {
//         const label = radio.nextElementSibling;
        
//         if (label && label.classList.contains('variant-option-button')) {
//           label.addEventListener('click', (e) => {
//             e.preventDefault();
//             e.stopPropagation();
            
//             console.log('🖱️ Clicked variant:', label.textContent.trim());
            
//             if (!radio.disabled && !label.classList.contains('variant-option-button--out-of-stock')) {
//               this.selectVariant(radio);
//             }
//           });
//         }

//         radio.addEventListener('change', () => {
//           if (radio.checked) {
//             console.log('🔄 Radio changed to:', radio.value);
//             this.updateVariantUI(radio);
//           }
//         });
//       });
      
//       console.log('✅ Event listeners attached to', this.variantRadios.length, 'variants');
//     }

//     selectVariant(selectedRadio) {
//       this.variantRadios.forEach(radio => {
//         radio.checked = false;
//       });

//       selectedRadio.checked = true;
//       selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
//     }

//     updateVariantUI(selectedRadio) {
//       const variantId = selectedRadio.dataset.variantId;
//       const price = parseInt(selectedRadio.dataset.variantPrice);
//       const comparePrice = selectedRadio.dataset.variantComparePrice !== 'undefined' && 
//                           selectedRadio.dataset.variantComparePrice !== 'null' && 
//                           selectedRadio.dataset.variantComparePrice !== '' ? 
//                           parseInt(selectedRadio.dataset.variantComparePrice) : null;
//       const available = selectedRadio.dataset.variantAvailable === 'true';
//       const variantImage = selectedRadio.dataset.variantImage;

//       console.log('🔄 Updating UI:', { variantId, price, available });

//       // Update product image
//       if (variantImage && this.mainImage) {
//         this.updateProductImage(variantImage);
//       }

//       // Update prices
//       this.updatePriceDisplay(price, comparePrice);

//       // Update hidden inputs
//       if (this.variantIdInput) this.variantIdInput.value = variantId;
//       if (this.variantIdInputCart) this.variantIdInputCart.value = variantId;

//       // Update quick buy modal
//       const quickBuyModal = this.productCard.querySelector('.quick-buy-modal');
//       if (quickBuyModal && this.productHandle) {
//         quickBuyModal.setAttribute('handle', this.productHandle + '?variant=' + variantId);
//       }

//       // Update button states
//       this.updateButtonStates(selectedRadio, available);
//     }

//     updateProductImage(imageUrl) {
//       if (!this.mainImage || !imageUrl) return;

//       this.mainImage.style.transition = 'opacity 0.3s ease';
//       this.mainImage.style.opacity = '0.3';
      
//       const newImage = new Image();
      
//       newImage.onload = () => {
//         this.mainImage.src = imageUrl;
//         this.mainImage.srcset = imageUrl;
        
//         setTimeout(() => {
//           this.mainImage.style.opacity = '1';
//         }, 50);
//       };
      
//       newImage.onerror = () => {
//         this.mainImage.style.opacity = '1';
//       };
      
//       newImage.src = imageUrl;
//     }

//     updatePriceDisplay(price, comparePrice) {
//       if (!this.priceWrapper) return;

//       const formattedPrice = this.formatMoney(price);
//       const formattedComparePrice = comparePrice ? this.formatMoney(comparePrice) : null;

//       let priceHtml = '';

//       if (comparePrice && comparePrice > price) {
//         const discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
//         priceHtml = `
//           <div class="price price--on-sale">
//             <span class="price__regular sale-price" style="color:#d73502; font-weight:500;">
//               ${formattedPrice}
//             </span>
//             <span class="price__compare">
//               <s class="text-subdued">${formattedComparePrice}</s>
//             </span>
//             <span class="price__discount" style="color:#006644; font-size:14px; font-weight:600; margin-left:5px;">
//               ${discountPercent}% Off
//             </span>
//           </div>
//         `;
//       } else {
//         priceHtml = `
//           <div class="price">
//             <span class="price__regular">${formattedPrice}</span>
//           </div>
//         `;
//       }

//       this.priceWrapper.innerHTML = priceHtml;
//     }

//     updateButtonStates(selectedRadio, available) {
//       // Update variant buttons visual state
//       this.variantRadios.forEach(radio => {
//         const label = radio.nextElementSibling;
//         if (label) {
//           label.classList.remove('variant-option-button--selected');
//         }
//       });

//       const selectedLabel = selectedRadio.nextElementSibling;
//       if (selectedLabel) {
//         selectedLabel.classList.add('variant-option-button--selected');
//       }

//       // Update add to cart button
//       if (this.addToCartButton) {
//         const buttonText = this.addToCartButton.querySelector('.add-to-cart-text');
//         if (buttonText) {
//           buttonText.textContent = available ? 'Add to Cart' : 'Sold Out';
//         }
//         this.addToCartButton.disabled = !available;
        
//         if (available) {
//           this.addToCartButton.classList.remove('product-card__add-to-cart-button--sold-out');
//         } else {
//           this.addToCartButton.classList.add('product-card__add-to-cart-button--sold-out');
//         }
//       }
//     }

//     initializeDefaultVariant() {
//       let defaultRadio = null;

//       if (this.defaultVariantId) {
//         defaultRadio = this.productCard.querySelector(`.variant-radio[value="${this.defaultVariantId}"]`);
//       }

//       if (!defaultRadio) {
//         defaultRadio = Array.from(this.variantRadios).find(radio => 
//           radio.dataset.variantAvailable === 'true'
//         );
//       }

//       if (!defaultRadio && this.variantRadios.length > 0) {
//         defaultRadio = this.variantRadios[0];
//       }

//       if (defaultRadio) {
//         console.log('✅ Default variant selected');
//         this.selectVariant(defaultRadio);
//       }
//     }

//     formatMoney(cents) {
//       const amount = cents / 100;
//       return amount % 1 === 0 ? '₹' + Math.round(amount) : '₹' + amount.toFixed(2);
//     }
//   }

//   // Initialize all product cards on the page
//   function initializeAllVariantSelectors() {
//     console.log('🔍 Scanning for product cards...');
//     const productCards = document.querySelectorAll('[data-product-id]');
//     console.log('📋 Found', productCards.length, 'product cards');
    
//     let initialized = 0;
//     productCards.forEach(card => {
//       if (card.dataset.variantSelectorInitialized !== 'true') {
//         new ProductVariantSelector(card);
//         initialized++;
//       }
//     });
    
//     console.log('✨ Initialized', initialized, 'new cards');
//   }

//   // Set up observer for dynamically loaded content
//   function setupDynamicObserver() {
//     console.log('👁️ Setting up MutationObserver...');
    
//     const observer = new MutationObserver((mutations) => {
//       let foundNewCards = false;
      
//       mutations.forEach((mutation) => {
//         mutation.addedNodes.forEach((node) => {
//           if (node.nodeType === 1) {
//             // Check if it's a product card
//             if (node.matches && node.matches('[data-product-id]')) {
//               console.log('🆕 New product card detected!');
//               new ProductVariantSelector(node);
//               foundNewCards = true;
//             }
//             // Check if it contains product cards
//             else if (node.querySelectorAll) {
//               const cards = node.querySelectorAll('[data-product-id]');
//               if (cards.length > 0) {
//                 console.log('🆕 Found', cards.length, 'new cards in container');
//                 cards.forEach(card => new ProductVariantSelector(card));
//                 foundNewCards = true;
//               }
//             }
//           }
//         });
//       });
      
//       if (foundNewCards) {
//         console.log('✅ New cards initialized via observer');
//       }
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
    
//     console.log('✅ MutationObserver active');
//   }

//   // Specifically watch for product-recommendations element
//   function watchProductRecommendations() {
//     console.log('🎯 Looking for product-recommendations elements...');
    
//     const recommendationElements = document.querySelectorAll('product-recommendations');
//     console.log('📦 Found', recommendationElements.length, 'recommendation element(s)');
    
//     recommendationElements.forEach((element, index) => {
//       console.log(`👁️ Watching recommendation element ${index + 1}...`);
      
//       // Check if already has content
//       const existingCards = element.querySelectorAll('[data-product-id]');
//       if (existingCards.length > 0) {
//         console.log('✅ Recommendation already has', existingCards.length, 'cards');
//         existingCards.forEach(card => new ProductVariantSelector(card));
//       }
      
//       // Watch for future changes
//       const observer = new MutationObserver((mutations) => {
//         mutations.forEach((mutation) => {
//           if (mutation.addedNodes.length > 0) {
//             console.log('🔄 Recommendation content changed!');
//             const cards = element.querySelectorAll('[data-product-id]');
//             console.log('📋 Now has', cards.length, 'cards');
//             cards.forEach(card => new ProductVariantSelector(card));
//           }
//         });
//       });
      
//       observer.observe(element, {
//         childList: true,
//         subtree: true
//       });
//     });
//   }

//   // Initialize everything
//   function init() {
//     console.log('🎬 Starting initialization...');
    
//     // Initial scan
//     initializeAllVariantSelectors();
    
//     // Set up observers
//     setupDynamicObserver();
//     watchProductRecommendations();
    
//     console.log('✅ Initial setup complete');
    
//     // Delayed scans for AJAX-loaded content
//     const delays = [500, 1000, 2000, 3000, 5000];
//     delays.forEach(delay => {
//       setTimeout(() => {
//         console.log(`⏰ Delayed scan at ${delay}ms...`);
//         initializeAllVariantSelectors();
//       }, delay);
//     });
//   }

//   // Start when DOM is ready
//   if (document.readyState === 'loading') {
//     console.log('⏳ Waiting for DOMContentLoaded...');
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     console.log('✅ DOM already loaded, starting immediately');
//     init();
//   }

//   // Listen for Shopify theme editor events
//   document.addEventListener('shopify:section:load', (e) => {
//     console.log('🛍️ Shopify section loaded:', e.detail);
//     setTimeout(initializeAllVariantSelectors, 200);
//   });

//   document.addEventListener('shopify:section:reorder', (e) => {
//     console.log('🔄 Shopify section reordered:', e.detail);
//     setTimeout(initializeAllVariantSelectors, 200);
//   });

//   // Listen for custom recommendations loaded event
//   document.addEventListener('recommendations:loaded', (e) => {
//     console.log('🎉 Recommendations loaded event received!', e.detail);
//     setTimeout(initializeAllVariantSelectors, 100);
//   });

//   // Expose function globally for direct calls
//   window.initializeAllVariantSelectors = initializeAllVariantSelectors;

//   console.log('✅ Variant Selector Script Loaded');

// })();

(function() {
  'use strict';

  console.log('Enhanced Variant Selector Loading');

  class ProductVariantSelector {
    constructor(productCard) {
      this.productCard = productCard;
      
      if (this.productCard.dataset.variantSelectorInitialized === 'true') {
        console.log('Card already initialized, skipping');
        return;
      }
      
      this.hasVariantSelector = this.productCard.querySelector('[data-variant-selector]') !== null;
      
      if (this.hasVariantSelector) {
        console.log('Initializing card:', this.productCard.dataset.productHandle);
        this.init();
        this.productCard.dataset.variantSelectorInitialized = 'true';
      }
    }

    init() {
      this.variantRadios = this.productCard.querySelectorAll('.variant-radio');
      this.priceWrapper = this.productCard.querySelector('[data-price-wrapper]');
      this.variantIdInput = this.productCard.querySelector('.variant-id-input');
      this.variantIdInputCart = this.productCard.querySelector('.variant-id-input-cart');
      this.addToCartButton = this.productCard.querySelector('.product-card__add-to-cart-button');
      this.defaultVariantId = this.productCard.dataset.defaultVariantId;
      this.productHandle = this.productCard.dataset.productHandle;
      this.mainImage = this.productCard.querySelector('[data-main-image="true"]');
      this.secondaryImage = this.productCard.querySelector('[data-secondary-image="true"]');
      this.imageWrapper = this.productCard.querySelector('.product-card__image-wrapper');

      if (this.variantRadios.length === 0) {
        console.log('No variant radios found');
        return;
      }

      this.setupEventListeners();
      this.setupImageHoverEffect();
      this.initializeDefaultVariant();
    }

    setupImageHoverEffect() {
      if (!this.imageWrapper || !this.mainImage || !this.secondaryImage) return;

      this.imageWrapper.addEventListener('mouseenter', () => {
        this.mainImage.style.opacity = '0';
        this.secondaryImage.style.opacity = '1';
      });

      this.imageWrapper.addEventListener('mouseleave', () => {
        this.mainImage.style.opacity = '1';
        this.secondaryImage.style.opacity = '0';
      });
    }

    setupEventListeners() {
      console.log('Setting up event listeners...');
      
      this.variantRadios.forEach((radio) => {
        const label = radio.nextElementSibling;
        
        if (label && label.classList.contains('variant-option-button')) {
          // CRITICAL: Remove the out-of-stock check to allow clicking
          label.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            console.log('Clicked variant:', label.textContent.trim(), 
                       'Available:', radio.dataset.variantAvailable);
            
            // Allow selection of ANY variant, including out-of-stock
            this.selectVariant(radio);
          });
        }

        radio.addEventListener('change', () => {
          if (radio.checked) {
            console.log('Radio changed to:', radio.value);
            this.updateVariantUI(radio);
          }
        });
      });
      
      console.log('Event listeners attached to', this.variantRadios.length, 'variants');
    }

    selectVariant(selectedRadio) {
      // Uncheck all radios
      this.variantRadios.forEach(radio => {
        radio.checked = false;
      });

      // Check the selected radio
      selectedRadio.checked = true;
      selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateVariantUI(selectedRadio) {
      const variantId = selectedRadio.dataset.variantId;
      const price = parseInt(selectedRadio.dataset.variantPrice);
      const comparePrice = selectedRadio.dataset.variantComparePrice !== 'undefined' && 
                          selectedRadio.dataset.variantComparePrice !== 'null' && 
                          selectedRadio.dataset.variantComparePrice !== '' ? 
                          parseInt(selectedRadio.dataset.variantComparePrice) : null;
      const available = selectedRadio.dataset.variantAvailable === 'true';
      const variantImage = selectedRadio.dataset.variantImage;

      console.log('Updating UI:', { variantId, price, available });

      // Update product image
      if (variantImage && this.mainImage) {
        this.updateProductImage(variantImage);
      }

      // Update prices
      this.updatePriceDisplay(price, comparePrice);

      // Update hidden inputs (even for out-of-stock variants)
      if (this.variantIdInput) this.variantIdInput.value = variantId;
      if (this.variantIdInputCart) this.variantIdInputCart.value = variantId;

      // Update quick buy modal
      const quickBuyModal = this.productCard.querySelector('.quick-buy-modal');
      if (quickBuyModal && this.productHandle) {
        quickBuyModal.setAttribute('handle', this.productHandle + '?variant=' + variantId);
      }

      // Update button states based on availability
      this.updateButtonStates(selectedRadio, available);
      
      // Update visual state of variant buttons
      this.updateVariantButtonsVisualState(selectedRadio);
    }

    updateProductImage(imageUrl) {
      if (!this.mainImage || !imageUrl) return;

      this.mainImage.style.transition = 'opacity 0.3s ease';
      this.mainImage.style.opacity = '0.3';
      
      const newImage = new Image();
      
      newImage.onload = () => {
        this.mainImage.src = imageUrl;
        this.mainImage.srcset = imageUrl;
        
        setTimeout(() => {
          this.mainImage.style.opacity = '1';
        }, 50);
      };
      
      newImage.onerror = () => {
        this.mainImage.style.opacity = '1';
      };
      
      newImage.src = imageUrl;
    }

    updatePriceDisplay(price, comparePrice) {
      if (!this.priceWrapper) return;

      const formattedPrice = this.formatMoney(price);
      const formattedComparePrice = comparePrice ? this.formatMoney(comparePrice) : null;

      let priceHtml = '';

      if (comparePrice && comparePrice > price) {
        const discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
        priceHtml = `
          <div class="price price--on-sale">
            <span class="price__regular sale-price" style="color:#d73502; font-weight:500;">
              ${formattedPrice}
            </span>
            <span class="price__compare">
              <s class="text-subdued">${formattedComparePrice}</s>
            </span>
            <span class="price__discount" style="color:#006644; font-size:14px; font-weight:600; margin-left:5px;">
              ${discountPercent}% Off
            </span>
          </div>
        `;
      } else {
        priceHtml = `
          <div class="price">
            <span class="price__regular">${formattedPrice}</span>
          </div>
        `;
      }

      this.priceWrapper.innerHTML = priceHtml;
    }

    updateVariantButtonsVisualState(selectedRadio) {
      // Remove selected state from all buttons
      this.variantRadios.forEach(radio => {
        const label = radio.nextElementSibling;
        if (label) {
          label.classList.remove('variant-option-button--selected');
        }
      });

      // Add selected state to current button
      const selectedLabel = selectedRadio.nextElementSibling;
      if (selectedLabel) {
        selectedLabel.classList.add('variant-option-button--selected');
      }
    }

    updateButtonStates(selectedRadio, available) {
      if (!this.addToCartButton) return;

      const buttonText = this.addToCartButton.querySelector('.add-to-cart-text');
      
      if (available) {
        // Variant is in stock
        if (buttonText) {
          buttonText.textContent = 'Add to Cart';
        }
        this.addToCartButton.disabled = false;
        this.addToCartButton.classList.remove('product-card__add-to-cart-button--sold-out');
        
        console.log('Button enabled: Add to Cart');
      } else {
        // Variant is out of stock
        if (buttonText) {
          buttonText.textContent = 'Sold Out';
        }
        this.addToCartButton.disabled = true;
        this.addToCartButton.classList.add('product-card__add-to-cart-button--sold-out');
        
        console.log('Button disabled: Sold Out');
      }
    }

    initializeDefaultVariant() {
      let defaultRadio = null;

      // Try to use the default variant ID
      if (this.defaultVariantId) {
        defaultRadio = this.productCard.querySelector(`.variant-radio[value="${this.defaultVariantId}"]`);
      }

      // If default variant doesn't exist or is unavailable, find first available
      if (!defaultRadio || defaultRadio.dataset.variantAvailable !== 'true') {
        defaultRadio = Array.from(this.variantRadios).find(radio => 
          radio.dataset.variantAvailable === 'true'
        );
      }

      // If no available variants, use the first one (even if out of stock)
      if (!defaultRadio && this.variantRadios.length > 0) {
        defaultRadio = this.variantRadios[0];
      }

      if (defaultRadio) {
        console.log('Initializing with variant:', defaultRadio.value, 
                   'Available:', defaultRadio.dataset.variantAvailable);
        this.selectVariant(defaultRadio);
      }
    }

    formatMoney(cents) {
      const amount = cents / 100;
      return amount % 1 === 0 ? '₹' + Math.round(amount) : '₹' + amount.toFixed(2);
    }
  }

  // Initialize all product cards
  function initializeAllVariantSelectors() {
    console.log('Scanning for product cards...');
    const productCards = document.querySelectorAll('[data-product-id]');
    console.log('Found', productCards.length, 'product cards');
    
    let initialized = 0;
    productCards.forEach(card => {
      if (card.dataset.variantSelectorInitialized !== 'true') {
        new ProductVariantSelector(card);
        initialized++;
      }
    });
    
    console.log('Initialized', initialized, 'new cards');
  }

  // Set up observer for dynamically loaded content
  function setupDynamicObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('[data-product-id]')) {
              new ProductVariantSelector(node);
            } else if (node.querySelectorAll) {
              const cards = node.querySelectorAll('[data-product-id]');
              cards.forEach(card => new ProductVariantSelector(card));
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize everything
  function init() {
    console.log('Starting initialization...');
    initializeAllVariantSelectors();
    setupDynamicObserver();
    
    // Delayed scans for AJAX content
    [500, 1000, 2000].forEach(delay => {
      setTimeout(initializeAllVariantSelectors, delay);
    });
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initializeAllVariantSelectors, 200);
  });

  window.initializeAllVariantSelectors = initializeAllVariantSelectors;

})();